import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Zap, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { hasProfile } from "@/lib/profile";
import { GstInvoiceFields } from "./GstInvoiceFields";

export const GuestDetailsForm = ({ form, onChange, idPrefix = "", gst, onGstChange, gstError }) => {
  const [showBanner, setShowBanner] = useState(() => hasProfile());
  const focusName = () => document.getElementById(`${idPrefix}guest_name`)?.focus();

  return (
    <div className="space-y-3">
      {showBanner && (
        <div data-testid="autofill-banner" className="flex items-center gap-2 rounded-xl bg-brand-soft border border-brand/15 px-3 py-2 text-xs text-brand-dark">
          <Zap className="w-3.5 h-3.5 shrink-0" aria-hidden="true" />
          <span className="flex-1">Autofilled from your previous visit</span>
          <button type="button" onClick={() => { setShowBanner(false); focusName(); }} className="font-semibold hover:underline" data-testid="autofill-edit">Edit</button>
          <button type="button" onClick={() => setShowBanner(false)} aria-label="Dismiss" className="opacity-60 hover:opacity-100"><X className="w-3.5 h-3.5" /></button>
        </div>
      )}
      <div>
        <Label htmlFor={`${idPrefix}guest_name`} className="text-xs text-ink-soft">Full name</Label>
        <Input id={`${idPrefix}guest_name`} name="guest_name" value={form.guest_name} onChange={onChange} placeholder="Your name" data-testid={`${idPrefix}guest-name`} className="mt-1 h-11 focus-visible:ring-brand" />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <Label htmlFor={`${idPrefix}guest_phone`} className="text-xs text-ink-soft">WhatsApp number (with country code)</Label>
          <Input id={`${idPrefix}guest_phone`} name="guest_phone" type="tel" value={form.guest_phone} onChange={onChange} placeholder="+91 98765 43210" data-testid={`${idPrefix}guest-phone`} className="mt-1 h-11 focus-visible:ring-brand" />
        </div>
        <div>
          <Label htmlFor={`${idPrefix}guest_email`} className="text-xs text-ink-soft">Email</Label>
          <Input id={`${idPrefix}guest_email`} name="guest_email" type="email" value={form.guest_email} onChange={onChange} placeholder="you@email.com" data-testid={`${idPrefix}guest-email`} className="mt-1 h-11 focus-visible:ring-brand" />
        </div>
      </div>
      <p className="text-[11px] text-ink-faint" data-testid={`${idPrefix}whatsapp-note`}>We'll send your booking updates here.</p>
      <p className="text-[11px] text-ink-faint">Indian or foreign number — always include the country code, e.g. +44 7400 123456.</p>
      <p className="text-[11px] text-ink-faint" data-testid={`${idPrefix}privacy-note`}>
        We use your phone and email only for this booking. <Link to="/privacy" className="underline hover:text-ink">Privacy policy</Link>
      </p>
      {gst && onGstChange && (
        <GstInvoiceFields value={gst} onChange={onGstChange} error={gstError} idPrefix={idPrefix} />
      )}
      <div>
        <Label htmlFor={`${idPrefix}special_requests`} className="text-xs text-ink-soft">Special requests (optional)</Label>
        <Textarea id={`${idPrefix}special_requests`} name="special_requests" value={form.special_requests} onChange={onChange} rows={2} placeholder="Early check-in, extra bed…" data-testid={`${idPrefix}guest-requests`} className="mt-1 focus-visible:ring-brand resize-none" />
      </div>
    </div>
  );
};

export default GuestDetailsForm;
